<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'DistributorOrderList' }">
          {{ $route.name === "firstDistributorOrderInfo" ? "已办订单" : "待办订单" }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name === "firstDistributorOrderInfo" ? "详细信息" : "办理" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <do-it-action-box v-if="$route.name === 'FirstDistributorOrder'" :document-id="$route.params.documentId" />
    <base-info :base-info="baseInfo" :loading="loading" />
    <distributor-product :table-data="productList" :loading="loading" />
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import doItActionBox from './doItActionBox';
import distributorProduct from './distributorProduct';
import { getPreferredBaseOrderDetailInfo } from '@/API';
export default {
  data () {
    return {
      baseInfo: {},
      productList: [],
      loading: false
    };
  },
  components: {
    baseInfo,
    distributorProduct,
    doItActionBox
  },
  computed: {},
  methods: {
    isLimit () {
      this.loading = true;
      getPreferredBaseOrderDetailInfo(this.$route.params.documentId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.baseInfo = json.data;
          this.productList = json.data.productList;
          this.loading = false;
        } else {
          this.loading = false;
          this.$router.push({ name: 'DistributorOrderList' });
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.isLimit();
  }
};
</script>
<style lang="scss">
  .rj-breadcrumb{
  .rj-tabs-body{
    padding-bottom:0!important;
  }
  }
</style>
